import React from 'react';
import {
  Loading, Success, Failed, Confirmation,
} from '.';

class Toaster extends React.Component {
  static ToasterState = {
    hidden: 'HIDDEN',
    confirming: 'CONFIRMING',
    loading: 'LOADING',
    success: 'SUCCESS',
    failed: 'FAILED',
  }

  constructor(props) {
    super(props);
    this.state = { toasterState: Toaster.ToasterState.hidden };
    this.showConfirmation = this.showConfirmation.bind(this);
    this.showLoading = this.showLoading.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.showFailed = this.showFailed.bind(this);
    this.hideToaster = this.hideToaster.bind(this);
  }


  showConfirmation(text, onConfirm, confirmText, onDismiss, dismissText) {
    this.setState({
      toasterState: Toaster.ToasterState.confirming,
      toasterText: text,
      onConfirm,
      confirmText,
      onDismiss,
      dismissText,
    });
  }

  showLoading(text) {
    this.setState({
      toasterState: Toaster.ToasterState.loading,
      toasterText: text,
    });
  }

  showSuccess(text, onDismiss) {
    this.setState({
      toasterState: Toaster.ToasterState.success,
      toasterText: text,
      onDismiss,
    });
  }

  showFailed(text, onDismiss, dismissText) {
    this.setState({
      toasterState: Toaster.ToasterState.failed,
      toasterText: text,
      onDismiss,
      dismissText,
    });
  }

  hideToaster() {
    this.setState({ toasterState: Toaster.ToasterState.hidden });
  }

  render() {
    let toaster = null;
    if (this.state.toasterState === Toaster.ToasterState.loading) {
      toaster = (<Loading text={this.state.toasterText} />);
    } else if (this.state.toasterState === Toaster.ToasterState.success) {
      toaster = (<Success text={this.state.toasterText} onDismiss={this.state.onDismiss} />);
    } else if (this.state.toasterState === Toaster.ToasterState.failed) {
      toaster = (
        <Failed
          text={this.state.toasterText}
          onDismiss={this.state.onDismiss}
          dismissText={this.state.dismissText}
        />
      );
    } else if (this.state.toasterState === Toaster.ToasterState.confirming) {
      toaster = (
        <Confirmation
          text={this.state.toasterText}
          onConfirm={this.state.onConfirm}
          confirmText={this.state.confirmText}
          onDismiss={this.state.onDismiss}
          dismissText={this.state.dismissText}
        />
      );
    }

    return toaster;
  }
}

export default Toaster;
